import { Theme, useMediaQuery } from '@material-ui/core';

export default function useIsMobile() {
  return useMediaQuery<Theme>(theme => theme.breakpoints.down('sm'));
}
